import React, { useEffect, useState, createContext, useContext } from 'react';
interface PricingData {
  oldPrice: string;
  newPrice: string;
  savings: string;
  bonusPrice: string;
  totalValue: string;
  isLoading: boolean;
}
const defaultPricing: PricingData = {
  oldPrice: '$47 USD',
  newPrice: '$9.99 USD',
  savings: 'AHORRAS $47 USD',
  bonusPrice: '',
  totalValue: '$385+ USD',
  isLoading: true
};
const GeoPricingContext = createContext<PricingData>(defaultPricing);
export function GeoPricingProvider({
  children
}: {
  children: ReactNode;
}) {
  const [pricing, setPricing] = useState<PricingData>(defaultPricing);
  useEffect(() => {
    const fetchLocation = async () => {
      try {
        const res = await fetch('https://ipapi.co/json/');
        const data = await res.json();
        const country = data.country_code;
        let newPrice = '$9.99 USD';
        let oldPrice = '$47 USD';
        let totalValue = '$385+ USD';
        if (country === 'MX') {
          newPrice = '$199 MXN';
          oldPrice = '$940 MXN';
          totalValue = '$7,700+ MXN';
        } else if (country === 'CO') {
          newPrice = '$39,900 COP';
          oldPrice = '$188,000 COP';
          totalValue = '$1,500,000+ COP';
        } else if (country === 'CL') {
          newPrice = '$9,900 CLP';
          oldPrice = '$47,000 CLP';
          totalValue = '$385,000+ CLP';
        } else if (country === 'PE') {
          newPrice = 'S/ 39.00 PEN';
          oldPrice = 'S/ 180.00 PEN';
          totalValue = 'S/ 1,500+ PEN';
        } else if (country === 'AR') {
          newPrice = '$9,900 ARS';
          oldPrice = '$47,000 ARS';
          totalValue = '$385,000+ ARS';
        } else if (country === 'ES') {
          newPrice = '9.99 €';
          oldPrice = '47 €';
          totalValue = '385+ €';
        }
        setPricing({
          oldPrice,
          newPrice,
          savings: `AHORRAS ${oldPrice}`,
          bonusPrice: '',
          totalValue,
          isLoading: false
        });
      } catch (error) {
        setPricing(prev => ({
          ...prev,
          isLoading: false
        }));
      }
    };
    fetchLocation();
  }, []);
  return <GeoPricingContext.Provider value={pricing} data-id="element-440">
      {children}
    </GeoPricingContext.Provider>;
}
export function useGeoPricingContext(): PricingData {
  return useContext(GeoPricingContext);
}